import { useEffect } from 'react';
    import { useDispatch, useSelector } from 'react-redux';
    import { fetchUserEntries } from '../../store/thunks/entriesThunk';

const EntriesLog = () => {
    const dispatch = useDispatch();
    const { entries, loading, error } = useSelector(state => state.entries);

    useEffect(() => {
        dispatch(fetchUserEntries());
    }, [dispatch]);

    if (loading) {
        return (
            <div className="bg-white rounded-lg p-4 shadow-sm">
                <h2 className="font-display text-xl font-bold mb-4">Your Entries</h2>
                <div className="text-center py-4">Loading entries...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-white rounded-lg p-4 shadow-sm">
                <h2 className="font-display text-xl font-bold mb-4">Your Entries</h2>
                <div className="text-center text-red-600 py-4">Error loading entries: {error}</div>
            </div>
        );
    }

    const entryType = (entryType) => {
        if (entryType === 'daily_photo') {
            return 'Daily Photo Contest';
        } else if (entryType === 'daily_trivia') {
            return 'Daily Trivia';
        } else if (entryType === 'daily_visit') {
            return 'Daily Visit';
        } else if (entryType === 'email_signup') {
            return 'Email Signup';
        } else if (entryType === 'social_share') {
            return 'Social Share';
        } else if (entryType === 'referral') {
            return 'Referral';
        }
    }

    const entriesEarned = (entry) => {
        if (entry.entryType === 'daily_photo') {
            // Get current date and entry date
            const currentDate = new Date();
            const entryDate = new Date(entry.timestamp);
            
            // Get start of current week (Monday)
            const startOfWeek = new Date(currentDate);
            startOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + (currentDate.getDay() === 0 ? -6 : 1));
            startOfWeek.setHours(0,0,0,0);
            
            // Get end of current week (Sunday) 
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            endOfWeek.setHours(23,59,59,999);

            // Check if entry is from current week
            if (entryDate >= startOfWeek && entryDate <= endOfWeek) {
                return 'TBD';
            }
            return entry.numberOfEntries;
        } else if (entry.entryType === 'daily_trivia') {
            return entry.numberOfEntries;
        } else {
            return entry.numberOfEntries;
        }
    }

    // Sort entries by timestamp in descending order (newest first)
    const sortedEntries = Array.isArray(entries) ? 
        [...entries].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)) : 
        [];

    return (
        <div className="bg-white rounded-lg p-4 shadow-sm">
            <h2 className="font-display text-xl font-bold mb-4">Your Entries</h2>
            
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Date
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Activity
                            </th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Entries Earned
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {sortedEntries.map((entry, index) => (
                            <tr key={index}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {new Date(entry.timestamp).toLocaleString()}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {entryType(entry.entryType)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    {entriesEarned(entry)}
                                </td>
                            </tr>
                        ))}
                        {(!entries || entries.length === 0) && (
                            <tr>
                                <td colSpan="3" className="px-6 py-4 text-center text-sm text-gray-500">
                                    No entries yet. Complete activities to earn entries!
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EntriesLog;
